<template>
	<td :style="style">
		<slot />
	</td>
</template>
<script lang="ts">
import { StyleValue } from "./table-types";
import { defineComponent, PropType } from "vue";

export default defineComponent({
	name: "TableCell",

	props: {
		padding: {
			type: String as PropType<string | null | undefined>,
			default: () => null
		},

		width: {
			type: String,
			default: () => "auto"
		},

		maxWidth: {
			type: String,
			default: () => "auto"
		},

		verticalAlign: {
			type: String,
			default: () => "middle"
		}
	},

	computed: {
		style(): StyleValue {
			const computedStyle: StyleValue = {
				width: this.width,
				maxWidth: this.maxWidth,
				verticalAlign: this.verticalAlign
			};
			if (this.padding) {
				computedStyle.padding = this.padding;
			}
			return computedStyle;
		}
	}
});
</script>
